export default __webpack_public_path__ + "static/media/NewAddIcon.f7dc2656.svg";